import { Component, Vue } from 'vue-property-decorator';
import { HSLColor } from '../types/color';

@Component
export default class ColorMixin extends Vue {
  picked: HSLColor = {
    h: '218',
    s: '77',
    l: '50',
  }
}
